import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import { Controller, UseControllerProps } from "react-hook-form";

import { DateTime } from "luxon";

import { ErrorForm } from "./ErrorForm.tsx";
import { LabelForm, LabelFormProps } from "./LabelForm.tsx";

type DatePickerFormProps = UseControllerProps &
  Omit<ReactDatePickerProps, "onChange"> &
  LabelFormProps;

export const DatePickerForm = (props: DatePickerFormProps) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      rules={props.rules}
      render={({ field, fieldState }) => {
        return (
          <div className="form-input">
            <LabelForm
              label={props.label}
              required={!!props.rules?.required}
              labelInfos={props.labelInfos}
            />
            <DatePicker
              {...props}
              locale="fr"
              dateFormat="dd/MM/yyyy"
              className={`w-100 ${
                fieldState.error && "form-input_field-error"
              } form-input_field date-select`}
              onChange={(date) =>
                date && field.onChange(DateTime.fromJSDate(date).toISO())
              }
              selected={field.value ? new Date(field.value) : undefined}
            />
            <ErrorForm error={fieldState.error} />
          </div>
        );
      }}
    />
  );
};
